import React from 'react';

class GoogleTagManager extends React.Component {
  componentDidMount() {
    if (process.env.NODE_ENV === 'production') {
      const script =
        '<script>(' +
        'function(w,d,s,l,i){' +
        "w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});" +
        "var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';" +
        "j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;" +
        'f.parentNode.insertBefore(j,f);})' +
        "(window,document,'script','dataLayer','GTM-KJ5Q4T');</script>";
      // eslint-disable-next-line no-undef
      $('head').prepend(script);
    }
  }

  render() {
    return null;
  }
}
export default GoogleTagManager;



// WEBPACK FOOTER //
// ./components/GoogleTagManager.jsx